module.exports = __webpack_public_path__ + "static/media/3-sustained-imagery.eea5a0e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/altcoin/3-sustained-imagery.mp3
// module id = au/b
// module chunks = 0